import fileaxiosInstance from "api/fileAxiosInstance"
import SAlert from "components/Alert"
import { batch } from "react-redux"
import { providerOutAction } from "./provider-out-slice"

// Get Provider Outs
export const getProviderOuts =
  (
    url,
    pageNumber = 10,
    according = { order: "desc", name: "id" },
    search = null,
    advancedSearch = {}
  ) =>
  dispatch => {
    dispatch(providerOutAction.setLoading(true))
    url = url || "/v1/provider-outs"
    fileaxiosInstance
      .get(url, {
        params: {
          pageNumber: pageNumber,
          according: according,
          search: search,
          advancedSearch: advancedSearch,
        },
      })
      .then(response => {
        if (response) {
          batch(() => {
            dispatch(providerOutAction.setError(null))
            dispatch(providerOutAction.setData(response.data))
            dispatch(providerOutAction.setLoading(false))
          })
        }
      })
      .catch(error => {
        dispatch(providerOutAction.setLoading(false))
        console.log(error)
      })
  }

// Delete  Multi Provider Outs
export const deleteManyProviderOut = ids => dispatch => {
  dispatch(providerOutAction.setLoading(true))
  fileaxiosInstance
    .post("/v1/provider-outs/delete/outs", { ids })
    .then(response => {
      dispatch(getProviderOuts())
      SAlert({ title: "Success", text: "Receipts successfully delete" })
      batch(() => {
        dispatch(providerOutAction.setError(null))
        dispatch(providerOutAction.setLoading(false))
      })
    })
    .catch(error => {
      if (error?.response?.data?.deleteError) {
        SAlert({
          text: error?.response?.data?.deleteError,
          status: "warning",
          timer: 5000,
        })
      }
      console.log(error)
    })
}

// Delete  Provider Outs
export const deleteProviderOut = id => dispatch => {
  dispatch(providerOutAction.setLoading(true))
  fileaxiosInstance
    .delete(`/v1/provider-outs/${id}`)
    .then(response => {
      dispatch(getProviderOuts())
      SAlert({ title: "Success", text: "Receipt successfully delete" })
      batch(() => {
        dispatch(providerOutAction.setError(null))
        dispatch(providerOutAction.setLoading(false))
      })
    })
    .catch(error => {
      if (error?.response?.data?.deleteError) {
        SAlert({
          text: error?.response?.data?.deleteError,
          status: "warning",
          timer: 5000,
        })
      }
      console.log(error)
    })
}

// Store  Provider Outs
export const storeProviderOut = (requests, navigate) => dispatch => {
  dispatch(providerOutAction.setLoading(true))
  fileaxiosInstance
    .post(`/v1/provider-outs`, requests)
    .then(response => {
      SAlert({ title: "Success", text: "Receipt successfully inserted" })
      navigate("/provider-distributions")
      batch(() => {
        dispatch(providerOutAction.setError(null))
        dispatch(providerOutAction.setLoading(false))
      })
    })
    .catch(error => {
      dispatch(providerOutAction.setLoading(false))
      dispatch(providerOutAction.setError(error?.response?.data?.errors))
      if (error?.response?.data?.error) {
        dispatch(
          providerOutAction.setStoreQuantityError(error?.response?.data?.error)
        )
      }
    })
}

// Update  Provider Outs
export const updateProviderOut = (id, form, navigate) => dispatch => {
  dispatch(providerOutAction.setLoading(true))
  fileaxiosInstance
    .post(`/v1/provider-outs/${id}`, form)
    .then(response => {
      navigate("/provider-distributions")
      SAlert({ title: "Success", text: "Receipt successfully updated" })
      batch(() => {
        dispatch(providerOutAction.setError(null))
        dispatch(providerOutAction.setLoading(false))
      })
    })
    .catch(error => {
      dispatch(providerOutAction.setLoading(false))
      dispatch(providerOutAction.setError(error?.response?.data?.errors))
      if (error?.response?.data?.err) {
        SAlert({
          title: "Success",
          text: error?.response?.data?.err,
          status: "warning",
        })
        navigate("/provider-distributions")
      }
    })
}

// Get Provider Outs By ID
export const getByIdProviderOut = id => dispatch => {
  dispatch(providerOutAction.setLoading(true))
  fileaxiosInstance
    .get(`/v1/provider-outs/${id}`)
    .then(response => {
      batch(() => {
        dispatch(providerOutAction.setError(null))
        dispatch(providerOutAction.setProviderOut(response?.data))
        dispatch(providerOutAction.setLoading(false))
      })
    })
    .catch(error => {
      dispatch(providerOutAction.setLoading(false))
      console.log(error)
    })
}

// Get Provider Outs Receipts
export const getProviderOutReceipts =
  (params = {}) =>
  dispatch => {
    dispatch(
      providerOutAction.setProviderOutReceipts({
        loading: true,
        error: null,
        data: null,
      })
    )
    fileaxiosInstance
      .get(`/v1/get-provider-out-receipts`, { params: params })
      .then(respnose => {
        dispatch(
          providerOutAction.setProviderOutReceipts({
            loading: false,
            error: null,
            data: respnose?.data,
          })
        )
      })
      .catch(error => {
        dispatch(
          providerOutAction.setProviderOutReceipts({
            loading: false,
            error: error?.response,
            data: null,
          })
        )
        console.log(error)
      })
  }

// Get Provider Out Provider Accounts
export const getProviderOutProviderAccounts = () => dispatch => {
  dispatch(
    providerOutAction.setProviderAccount({
      loading: true,
      error: null,
      data: null,
    })
  )
  fileaxiosInstance
    .get(`/v1/get-provider-out-providerAccounts`)
    .then(respnose => {
      dispatch(
        providerOutAction.setProviderAccount({
          loading: false,
          error: null,
          data: respnose?.data,
        })
      )
    })
    .catch(error => {
      dispatch(
        providerOutAction.setProviderAccount({
          loading: false,
          error: error?.response,
          data: null,
        })
      )
      console.log(error)
    })
}

// Get Provider Non Ips
export const getProviderNonIps = ip_id => dispatch => {
  dispatch(
    providerOutAction.setNoneIps({
      loading: true,
      error: null,
      data: null,
    })
  )
  fileaxiosInstance
    .get(`/v1/get-provider-out-non-ips/${ip_id}`)
    .then(respnose => {
      dispatch(
        providerOutAction.setNoneIps({
          loading: false,
          error: null,
          data: respnose?.data,
        })
      )
    })
    .catch(error => {
      dispatch(
        providerOutAction.setNoneIps({
          loading: false,
          error: error?.response,
          data: null,
        })
      )
      console.log(error)
    })
}

// Draft Actions

// Get Provider Out Drafts
export const getProviderOutDrafts = () => dispatch => {
  dispatch(
    providerOutAction.setDrafts({
      loading: true,
      error: null,
      data: [],
    })
  )

  fileaxiosInstance
    .get("/v1/provider-outs-draft")
    .then(response => {
      dispatch(
        providerOutAction.setDrafts({
          loading: false,
          error: null,
          data: response.data.data?.data || response.data.data || [],
        })
      )
    })
    .catch(error => {
      dispatch(
        providerOutAction.setDrafts({
          loading: false,
          error: error?.response?.data?.message || "Failed to fetch drafts",
          data: [],
        })
      )
      console.log(error)
    })
}

// Store Provider Out Draft
export const storeProviderOutDraft = draftData => dispatch => {
  dispatch(providerOutAction.setDraftLoading(true))

  const formData = new FormData()

  // Append all draft data
  formData.append("data", JSON.stringify(draftData))

  // Append the file if it exists
  if (draftData.document) {
    formData.append("document", draftData.document)
  }

  fileaxiosInstance
    .post("/v1/provider-outs-draft", formData)

    .then(response => {
      dispatch(providerOutAction.addDraft(response.data.data))
      dispatch(providerOutAction.setDraftLoading(false))
      // Reload all drafts to get the latest data
      dispatch(getProviderOutDrafts())
      SAlert({
        title: "Success",
        text: "Draft saved successfully",
        status: "success",
      })
    })
    .catch(error => {
      dispatch(providerOutAction.setDraftLoading(false))
      SAlert({
        text: error?.response?.data?.message || "Failed to save draft",
        status: "error",
      })
      console.log(error)
    })
}

// Update Provider Out Draft (Simple Modal Edit)
export const updateProviderOutDraftSimple = (id, data) => dispatch => {
  dispatch(providerOutAction.setDraftLoading(true))

  return fileaxiosInstance
    .put(`/v1/provider-outs-draft/${id}`, data)
    .then(response => {
      dispatch(providerOutAction.updateDraft(response.data.data))
      dispatch(providerOutAction.setDraftLoading(false))
      // Reload all drafts to get the latest data
      dispatch(getProviderOutDrafts())
      SAlert({
        title: "Success",
        text: "Draft updated successfully",
        status: "success",
      })
      return response
    })
    .catch(error => {
      dispatch(providerOutAction.setDraftLoading(false))
      SAlert({
        text: error?.response?.data?.message || "Failed to update draft",
        status: "error",
      })
      console.log(error)
      throw error
    })
}

// Update Provider Out Draft (Full Form Data)
export const updateProviderOutDraft = (id, formData) => dispatch => {
  dispatch(providerOutAction.setDraftLoading(true))

  return fileaxiosInstance
    .post(`/v1/provider-outs-draft/${id}`, formData)
    .then(response => {
      dispatch(providerOutAction.updateDraft(response.data.data))
      dispatch(providerOutAction.setDraftLoading(false))
      // Reload all drafts to get the latest data
      dispatch(getProviderOutDrafts())
      SAlert({
        title: "Success",
        text: "Draft updated successfully",
        status: "success",
      })
      return response
    })
    .catch(error => {
      dispatch(providerOutAction.setDraftLoading(false))
      SAlert({
        text: error?.response?.data?.message || "Failed to update draft",
        status: "error",
      })
      console.log(error)
      throw error
    })
}

// Delete Provider Out Draft
export const deleteProviderOutDraft = id => dispatch => {
  dispatch(providerOutAction.setDraftLoading(true))

  fileaxiosInstance
    .delete(`/v1/provider-outs-draft/${id}`)
    .then(response => {
      dispatch(providerOutAction.removeDraft(id))
      dispatch(providerOutAction.setDraftLoading(false))
      // Reload all drafts to get the latest data
      dispatch(getProviderOutDrafts())
      SAlert({
        title: "Success",
        text: "Draft deleted successfully",
        status: "success",
      })
    })
    .catch(error => {
      dispatch(providerOutAction.setDraftLoading(false))
      SAlert({
        text: error?.response?.data?.message || "Failed to delete draft",
        status: "error",
      })
      console.log(error)
    })
}

// Delete Multiple Provider Out Drafts
export const deleteManyProviderOutDrafts = ids => dispatch => {
  dispatch(providerOutAction.setDraftLoading(true))

  fileaxiosInstance
    .post("/v1/provider-outs-draft/delete-many", { ids })
    .then(response => {
      ids.forEach(id => dispatch(providerOutAction.removeDraft(id)))
      dispatch(providerOutAction.setDraftLoading(false))
      // Reload all drafts to get the latest data
      dispatch(getProviderOutDrafts())
      SAlert({
        title: "Success",
        text: "Drafts deleted successfully",
        status: "success",
      })
    })
    .catch(error => {
      dispatch(providerOutAction.setDraftLoading(false))
      SAlert({
        text: error?.response?.data?.message || "Failed to delete drafts",
        status: "error",
      })
      console.log(error)
    })
}

// Get Provider Out Draft By ID
export const getByIdProviderOutDraft = id => dispatch => {
  dispatch(providerOutAction.setLoading(true))

  fileaxiosInstance
    .get(`/v1/provider-outs-draft/${id}`)
    .then(response => {
      dispatch(providerOutAction.setError(null))
      dispatch(providerOutAction.setProviderOut(response?.data))
      dispatch(providerOutAction.setLoading(false))
    })
    .catch(error => {
      dispatch(providerOutAction.setLoading(false))
      dispatch(
        providerOutAction.setError(
          error?.response?.data?.message || "Failed to fetch draft"
        )
      )
      console.log(error)
    })
}

export const updateProviderOutDraftsToSubmitted = navigate => dispatch => {
  dispatch(providerOutAction.setLoading(true))
  fileaxiosInstance
    .patch(`/v1/provider-outs-update-drafts-status`, { status: "submitted" })
    .then(response => {
      // Clear drafts from state after successful submission
      // dispatch(providerOutAction.setDrafts([]))
      dispatch(providerOutAction.resetDrafts())
      navigate("/provider-distributions")
      SAlert({ title: "Success", text: "All drafts submitted successfully" })
      dispatch(providerOutAction.setLoading(false))
    })
    .catch(error => {
      dispatch(providerOutAction.setLoading(false))
      SAlert({ title: "Error", text: "Failed to submit drafts" })
    })
}
